import React, { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";

// Uploads a file and returns a served URL via onChange(url).
// visibility="public" for logos/covers (image tags), "private" for documents.
export default function FileUpload({ value, onChange, visibility = "public", accept = "image/*", label = "Upload image", preview = true }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("visibility", visibility);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const url = `${API}/files/${data.id}/download`;
      onChange(url, data);
      toast.success("Uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      {preview && value && accept.includes("image") && (
        <img src={value} alt="" className="w-14 h-14 object-cover border border-white/10 bg-bd-black" />
      )}
      <label className="inline-flex items-center gap-2 cursor-pointer border border-white/20 text-bd-ivory/70 hover:border-bd-gold hover:text-bd-gold transition-colors px-4 py-2.5 text-xs tracking-wider uppercase">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
        {value ? "Replace" : label}
        <input type="file" className="hidden" accept={accept} onChange={handle} />
      </label>
    </div>
  );
}
